<div>
  <div class="header">
    <div class="header-subtitle-admin">{{'' | i18n: 'age-and-mileage'}}.</div>
    <div>
      <div class="button-container">
        <button (click)="addNewConfiguration()">{{'' | i18n: 'add-item'}}</button>
      </div>
    </div>
  </div>

  <div>{{'' | i18n: 'search-make'}}:</div>

  <div class="brand-container">
    <div class="brand-selector">
      <select [(ngModel)]="selectedBrand" (change)="onBrandSelected()">
        @for (brand of brands; track brand) {
          <option [ngValue]="brand">{{brand.name}}</option>
        }
      </select>
    </div>
    <div class="paginator">
      <span style="width: 20px">
        <button class="button button-page" (click)="changePage(-1)" [disabled]="this.filter.page == 0">
          <img alt="" src="assets/images/BMW-previous-144.png" width="20px" height="20px">
        </button>
      </span>
      <span class="pagination-number"> {{filter.page + 1}} </span>
      <span style="width: 20px">
        <button class="button page-button" (click)="changePage(1)"
          [disabled]="this.ageMileageMatrix?.pageCount <= this.filter.page">
          <img alt="" src="assets/images/BMW-next-144.png" width="20px" height="20px">
        </button>
      </span>
    </div>
  </div>

  <!-- Table -->
  <div class="form-row-container-config">
    <div class="table-header">
      <div class="tbl-10">
        <a (click)="orderBy('CATEGORY')">{{'' | i18n: 'category'}}
          @if (filter.orderBy == 'CATEGORY') {
            <img src="{{updateIconStatus()}}" alt="" class="sort-img"/>
          }
        </a>
      </div>
      <div class="tbl-10">
        <a (click)="orderBy('AGE')">{{'' | i18n: 'age'}}
          @if (filter.orderBy == 'AGE') {
            <img src="{{updateIconStatus()}}" alt="" class="sort-img"/>
          }
        </a>
      </div>
      <div class="tbl-10">
        <a (click)="orderBy('MILEAGE')">{{'' | i18n: 'kilometrage'}}
          @if (filter.orderBy == 'MILEAGE') {
            <img src="{{updateIconStatus()}}" alt="" class="sort-img"/>
          }
        </a>
      </div>
      <div class="tbl-40">{{'' | i18n: 'description'}}</div>
      <div class="tbl-5">{{'' | i18n: 'action'}}</div>
    </div>

    @for (m of ageMileageMatrix?.dataList; track m) {
      <div class="table-list">
        <div class="tbl-content-10"><input type="text" [(ngModel)]="m.category"></div>
        <div class="tbl-content-10"><input type="number" [(ngModel)]="m.age"></div>
        <div class="tbl-content-10"><input type="number" [(ngModel)]="m.kilometrage"></div>
        <div class="tbl-content-40">
          <span>{{''| i18n:'up-to'}}&nbsp;</span>
          <span>{{getAgeInYears(m.age)}}&nbsp;</span>
          <span>{{''| i18n:'year-and-max'}}&nbsp;</span>
          <span>{{getMileage(m.kilometrage)}}&nbsp;</span>
          <span>km</span>
        </div>
        <div class="button-spacing">
          @if (m.id) {
            <button class="button button-white" (click)="updateItem(m)">{{'' | i18n: 'update'}}</button>
          }
          @if (!m.id) {
            <button class="button button-white" (click)="updateItem(m)">{{'' | i18n: 'save'}}</button>
          }
        </div>
        @if (!m.id) {
          <div class="button-spacing">
            <button class="button button-white" (click)="removeItem(m)">{{'' | i18n: 'delete'}}</button>
          </div>
        }
      </div>
    }
  </div>

</div>
